import api from "./api";

// Fetch all charging sessions
export const getSessions = async () => {
  const res = await api.get("/sessions");
  return res.data;
};

// Optionally: fetch a single session by ID
export const getSessionById = async (id) => {
  const res = await api.get(`/sessions/${id}`);
  return res.data;
};

// Optionally: create a new session
export const createSession = async (payload) => {
  const res = await api.post("/sessions", payload);
  return res.data;
};

// Optionally: end a session
export const endSession = async (id) => {
  const res = await api.post(`/sessions/${id}/end`);
  return res.data;
};
